import { Component, Input, OnInit } from '@angular/core';
import { EditService } from "../services/edit.service";
import { ActivatedRoute, Router } from "@angular/router";
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { AuthService } from "../services/auth.service";
import { HttpClient } from "@angular/common/http";
import { sha256 } from "js-sha256";
import { EncryptDecryptService } from "../services/encrypt-decrypt.service";
import swal from 'sweetalert2';
import { VariablesGlobales } from '../services/globals';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { User } from '../models/user';

@Component({
  selector: 'app-edit-password',
  templateUrl: './edit-password.component.html',
  styleUrls: ['./edit-password.component.css']
})
export class EditPasswordComponent implements OnInit {
  @Input() new_pass;
  @Input() conf_pass;

  showDetails: boolean;
  durationInSeconds = 15;
  returnUrl: string;
  apikey: string;
  user: any;

  public controlForm: FormGroup;

  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  lowerMsg: string = "contient au moins un caractere en minuscule.";
  upperMsg: string = "contient au moins un caractere en majuscule.";
  digitMsg: string = "contient au moins un chiffre.";
  speCaracMsg: string = "contient au moins un caractere spécial";
  lengthMinMsg: string = "contient au moins 8 caractères."
  constructor(public param: VariablesGlobales, private encdec: EncryptDecryptService, private http: HttpClient, private authService: AuthService, private _snackBar: MatSnackBar, private editService: EditService, private route: ActivatedRoute, private router: Router) {
    this.controlForm = new FormGroup({
      pass: new FormControl(this.new_pass, [
        Validators.required,
        Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$')
      ]),
      confPass: new FormControl(this.new_pass, [
        Validators.required
      ])
    });
  }
  get pass(): string {
    return this.controlForm.get('pass').value;
  }

  get confPass(): string {
    return this.controlForm.get('confPass').value;
  }

  ngOnInit(): void {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    this.apikey = localStorage.getItem('apikey')
    this.user = JSON.parse(localStorage.getItem('currentUser'));
  }

  onSubmit() {
    const obj: userInfo = {
      idcandidat: this.user.idcandidat,
      passe: sha256(this.controlForm.get('pass').value)
    }
    let data = this.encdec.getEncrypt(JSON.stringify(obj));
    const formData = new FormData();
    formData.append('datas', data);
    this.http.post('https://api2.sitederecrutement.com/Home/updatecandidate?apikey=' + this.apikey, formData, { responseType: "text" }).subscribe(
      (result) => {

        let data = this.encdec.getDecrypt(result);
        let obj = JSON.parse(data);
        const user: User = {
          idcandidat: obj.idcandidat,
          can_echec_connexion: obj.can_echec_connexion,
          can_echec_connexion_date: obj.can_echec_connexion_date,
          can_echec_connexion_heure: obj.can_echec_connexion_heure,
          can_passe_date: obj.can_passe_date,
          candidat_api: obj.can_session_api,
          can_passe_modif: obj.can_passe_modif,
          photo: obj.photo,
          consentement: obj.consentement,
          nom: obj.can_nom,
          prenom: obj.can_prenom,
          mail: obj.can_mail,
          portable: obj.can_tel_mob
        }
        localStorage.setItem('currentUser', JSON.stringify(user));

        swal.fire({
          title: "Félicitations !",
          text: "Votre mot de passe a bien été modifié.",
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-rose",
          },
          icon: "success",
          iconColor: 'd '
        });
        this.param.editPassword = false;
        this.param.editPasswordForced = false;
        this.param.editProfil = true;
      },
      error => {
        console.log("Une erreur est survenue");
      }
    )
  }

  onStrengthChanged(strength: number) {

  }
}

interface userInfo {
  idcandidat: string,
  passe: string
}
